import copy from 'copy-to-clipboard';

export default {
  init() {
    if (!this.component) {
      return;
    }

    this.addEventListeners();
  },

  addEventListeners() {
    this.component.forEach((copyElement) => {
      copyElement.addEventListener('click', this.handleClick.bind(this));
    });
  },

  handleClick(e) {
    copy(e.target.getAttribute('data-copy'));

    this.setMessage(e.target);
  },

  /* eslint-disable */
  setMessage(btn) {
    btn.value = 'Copiado!';

    window.setTimeout(() => {
      btn.value = 'Copiar';
    }, 3000);
  },
  /* eslint-enable */

  component: document.querySelectorAll('[data-component="copy-to-clipboard"]'), // eslint-disable-line
};
